<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">项目付款支付申请表</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn"
        >返回项目详情</a
      >
    </div>
    <div class="form-content" v-if="project.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <el-form-item label="需求类型">
            <el-radio-group
              :disabled="hasApplyId"
              v-model="contractType"
              class="type-radio-type"
            >
              <el-radio-button label="1">工程集团审批</el-radio-button>
              <el-radio-button label="2">工程子公司内部审批</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <create-pay-approval
            ref="create"
            :project="project"
            :userData="userData"
            :formByFather="form"
          >
          </create-pay-approval>

          <div class="tip" style="margin: 20px 0 0 40px">
            * 相关附件
            <!-- <p class="tip-sm">
              附件:合同条款复印件、工程支付月报表等。
            </p> -->
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments
                :projectId="form.projectId"
                :contractId="form.contractId"
                ref="attachments"
                :arr="attachmentArr"
                :type="14"
              ></attachments>
            </el-form-item>
          </div>

          <div class="tip" style="margin: 20px 0 0 40px">* 意见与审批</div>
          <div class="clear label-mx">
            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item
              ref="approval"
              :approvalUsers="approvalUsersData"
              :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"
            ></approval-item>
          </div>

          <div class="tip tip-table">
            <p>
              <span class="tip-lable">注：</span
              >1、本表作为水务集团有限公司内部流转项目付款审批表，附发票一起审批；
            </p>
            <p>2、本表一式二份，付款单位、集团公司战略企划部各执一份。</p>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button
                :loading="formLoading"
                @click="createProject()"
                class="form-btn"
                type="success"
                >确认提交项目付款支付申请表
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";
import approvalUsers from "@/Mixins/approvalUsers";

import ApprovalItem from "@/components/ApprovalItem";
import CreatePayApproval from "@/page/form/createPayApproval";

import ObjectUtil from "../mixins/objectUtil";
export default {
  components: {
    ApprovalItem,
    CreatePayApproval,
    Attachments,
  },
  mixins: [approvalUsers, ObjectUtil],
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      hasApplyId: "",
      contractType: "",

      project: {},
      form: {
        isAlone: false,

        name: "",
        payTypeId: "",
        projectId: "",
        bcjk: "",
        bqshjk: "",
        bqzf: "",
        fkdw: "",
        htdf: "",
        htjk: "",
        htmc: "",
        jbr: "",
        kxlb: "",
        ljzfjk: "",
        wtfs: "",
        xmgldw: "",
        zfqs: "",
        zfzshzj: "",
        remark:
          "根据合同款中约定，“    ”，经审核，本期付款金额为（大写）  元整  （小写￥    元），申请予以支付。",

        // 支付审批对象, 即是不是原水 1：原水 0：非原水
        type: "",

        // 是否线下审批通过
        underLine: "",
      },
      // 附件
      // attachments: "",

      approvalUsersData: "",
      isYuanshui: false,
      // approvalUsers.c14

      // 审批
      approvalType: "0",
      formLoading: false,

      applyInfo: "",
      attachmentArr: [],
    };
  },
  created() {},
  mounted() {
    this.form.projectId = this.$route.params.projectId;
    this.getProject();
    this.form.fkdw = this.userData.department.split("/")[0];
  },
  methods: {
    setApprovalUser() {
      // 如果微型项目，默认子公司审批
      if (this.project.type == 3 || this.project.type == 4) {
        this.contractType = 2;
      } else {
        this.contractType = 1;
        if (this.userData.deptDetail) {
          // 原水向集团
          this.form.type = 1;
        } else if (this.userData.secDepIds.split(",")[0] == "7") {
          // 集团内部
          this.form.type = 4;
        } else {
          // 子公司向集团
          this.form.type = 0;
        }
      }
      this.approvalUsersData = this.approvalUsers["c14_" + this.form.type];

      this.getApplyData();
    },
    // 获取审批表原内容
    getApplyData() {
      this.hasApplyId = this.$route.params.applyId ? true : false;
      this.form.applyId = this.$route.params.applyId;
      if (this.form.applyId) {
        this.formLoading = true;
        this.getProjectApplyInfo();
      } else {
        // this.setSelectArr(this.applyInfo, 14, this.form.type / 1)
      }
    },
    // 获取原审批表内容
    getProjectApplyInfo() {
      ajax.get("/gc/project/pay/apply/info/" + this.form.applyId, "", (res) => {
        this.applyInfo = res.vo;

        this.form.name = this.applyInfo.name;
        this.form.payTypeId = this.applyInfo.payTypeId;
        this.form.type = this.applyInfo.type;
        this.form.bcjk = this.applyInfo.bcjk;
        this.form.bqshjk = this.applyInfo.bqshjk;
        this.form.bqzf = this.applyInfo.bqzf;
        this.form.fkdw = this.applyInfo.fkdw;
        this.form.htdf = this.applyInfo.htdf;
        this.form.htjk = this.applyInfo.htjk;
        this.form.htmc = this.applyInfo.htmc;
        this.form.jbr = this.applyInfo.jbr;
        this.form.kxlb = this.applyInfo.kxlb;
        this.form.ljzfjk = this.applyInfo.ljzfjk;
        this.form.wtfs = this.applyInfo.wtfs;
        this.form.xmgldw = this.applyInfo.xmgldw;
        this.form.zfqs = this.applyInfo.zfqs;
        this.form.zfzshzj = this.applyInfo.zfzshzj;
        this.form.remark = this.applyInfo.remark;

        // 是否线下通过审批
        this.form.underLine = this.applyInfo.underLine.toString();

        this.attachmentArr = this.applyInfo.attachments
          ? this.applyInfo.attachments
          : [];

        this.setSelectArr(this.applyInfo, 14, this.form.type / 1);
        this.formLoading = false;
      });
    },
    // 获取当前项目
    getProject() {
      ajax.get("/gc/project/detail/" + this.form.projectId, "", (res) => {
        this.project = res.vo;

        // 修改当前选中的侧边栏
        this.setNavType(this.project);

        this.form.htjk = this.project.htzj;
        this.form.htmc = this.project.htmc;
        this.form.htdf = this.project.customer;

        this.setApprovalUser();
      });
    },
    // 提交申请
    createProject() {
      if (this.$refs.create.getFromData()) {
        this.form = this.$refs.create.getFromData();
      } else {
        return;
      }

      // 赋值合同ID
      this.form.contractId = this.project.contractId;

      this.form.approvalType = this.approvalType;
      this.form.approvalUserIds = this.$refs.approval.getUserIds();
      this.form.attachments = this.$refs.attachments.getAttachments();

      console.log(this.form.approvalUserIds);
      this.formLoading = true;
      let _url = !this.form.applyId
        ? "/gc/project/pay/apply"
        : "/gc/project/pay/apply/edit";

      ajax.post(
        _url,
        this.form,
        (res) => {
          this.$message.success("提交项目款项支付审批成功，请耐心等待领导审批");
          this.$router.back();
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {
    contractType() {
      // console.log('aaa')
      if (this.contractType == 2) {
        // 子公司
        if (this.userData.deptDetail) {
          // 原水
          this.form.type = 3;
        } else {
          // 通用子公司
          this.form.type = 2;
        }
      } else {
        if (this.userData.deptDetail) {
          // 原水向集团
          this.form.type = 1;
        } else if (this.userData.secDepIds.split(",")[0] == "7") {
          // 集团内部
          this.form.type = 4;
        } else {
          // 子公司向集团
          this.form.type = 0;
        }
      }
    },
    "form.type"() {
      // console.log(this.form.type)
      this.approvalUsersData = this.approvalUsers["c14_" + this.form.type];
      this.setSelectArr(this.applyInfo, 14, this.form.type / 1);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/createPayApproval.vue